import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { DeviationResourceType } from '../../../types/deviation';
import { BiData } from '@wix/da-bi/pkg/events';
const ViewVariant = ({ tier, className, size = 'medium' })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(GhostButton, {
        className: className,
        size: size,
        variant: "main",
        href: Url.userSubscriptionsPath({
            username: tier.author.username,
            tierDeviationId: tier.deviationId,
            tierContentType: 'deviations'
        }),
        biData: BiData({
            evid: 544,
            typeid: DeviationResourceType.TIER,
            itemid: tier.deviationId
        })
    }, t('deviation.tier.viewSubscription'));
};
ViewVariant.displayName = 'ViewVariant';
export default ViewVariant;
